(function () {

  'use strict';


  var root =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';


  var drawer;
  var overlay;
  var closeButton;

  var scrollArea;
  var content;
  var footer;

  var count;
  var total;
  var mobileTotal;

  var normalCheckoutButton;
  var mobileCheckout;
  var mobileCheckoutButton;

  var discount;
  var discountToggle;
  var discountContent;
  var discountInput;
  var discountApply;
  var discountMessage;

  var appliedDiscount;
  var appliedCode;
  var appliedSaving;
  var discountRemove;

  var tradeSummary;
  var tradeSaving;

  var refreshTimer = null;
  var drawerInitialised = false;
  var cartActionRunning = false;
  var checkoutObserver = null;

  var tradePricingActive = false;
  var tradePricingGeneration = 0;

  /*
   * Successful WSAIO prices may be cached.
   *
   * IMPORTANT:
   * Failed/null lookups are NEVER cached.
   */
  var wsaioPriceCache = {};


  /* =========================================================
     MONEY / GENERAL HELPERS
     ========================================================= */


  function formatMoney(cents) {

    try {

      return new Intl.NumberFormat(
        'en-GB',
        {
          style: 'currency',
          currency: 'GBP'
        }
      ).format(
        cents / 100
      );

    } catch (error) {

      return '£' +
        (cents / 100).toFixed(2);

    }

  }


  function escapeHtml(value) {

    if (
      value === null ||
      value === undefined
    ) {
      return '';
    }

    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

  }


  function parseMoneyText(value) {

    if (!value) {
      return null;
    }

    var text =
      String(value)
        .replace(/\s/g, '')
        .replace(/,/g, '');

    var match =
      text.match(
        /-?\d+(?:\.\d{1,2})?/
      );

    if (!match) {
      return null;
    }

    var amount =
      parseFloat(
        match[0]
      );

    if (!isFinite(amount)) {
      return null;
    }

    return Math.round(
      amount * 100
    );

  }


  function getDisplayLinePrice(item) {

    if (
      item &&
      typeof item.final_line_price ===
      'number'
    ) {

      return item.final_line_price;

    }

    if (
      item &&
      typeof item.line_price ===
      'number'
    ) {

      return item.line_price;

    }

    if (
      item &&
      typeof item.original_line_price ===
      'number'
    ) {

      return item.original_line_price;

    }

    return 0;

  }


  /*
   * Retail promo display:
   *
   * When a normal customer has entered a promo code, the
   * product line should show its price BEFORE that promo.
   *
   * The promo saving is then shown separately below the cart,
   * followed by Shopify's discounted Estimated Total.
   *
   * WSAIO does not use this helper. Trade pricing continues to
   * be applied separately by applyWsaiopricingToDrawer().
   */
  function getOriginalRetailLinePrice(item) {

    if (
      item &&
      typeof item.original_line_price ===
      'number'
    ) {

      return item.original_line_price;

    }

    if (
      item &&
      typeof item.line_price ===
      'number'
    ) {

      return item.line_price;

    }

    if (
      item &&
      typeof item.final_line_price ===
      'number'
    ) {

      return item.final_line_price;

    }

    return 0;

  }


  function getShopifyUnitPrice(item) {

    if (
      item &&
      typeof item.price ===
      'number'
    ) {

      return item.price;

    }

    if (
      item &&
      typeof item.final_price ===
      'number'
    ) {

      return item.final_price;

    }

    return 0;

  }


  function customerIsLoggedIn() {

    if (!drawer) {
      return false;
    }

    return (
      drawer.getAttribute(
        'data-rp-customer-logged-in'
      ) === 'true'
    );

  }


  /* =========================================================
     TRADE SESSION MEMORY
     ========================================================= */


  function markTradeSession() {

    try {

      sessionStorage.setItem(
        'rpWsaioTradeSession',
        'true'
      );

    } catch (error) {}

  }


  function clearTradeSession() {

    try {

      sessionStorage.removeItem(
        'rpWsaioTradeSession'
      );

    } catch (error) {}

  }


  function isKnownTradeSession() {

    if (
      !customerIsLoggedIn()
    ) {
      return false;
    }

    try {

      return (
        sessionStorage.getItem(
          'rpWsaioTradeSession'
        ) === 'true'
      );

    } catch (error) {

      return false;

    }

  }


  /* =========================================================
     MANUAL DISCOUNT STORAGE
     ========================================================= */


  function getStoredDiscount() {

    try {

      var value =
        sessionStorage.getItem(
          'rpCartDiscount'
        );

      return value
        ? JSON.parse(value)
        : null;

    } catch (error) {

      return null;

    }

  }


  function storeDiscount(
    code,
    saving
  ) {

    try {

      sessionStorage.setItem(
        'rpCartDiscount',
        JSON.stringify({
          code: code,
          saving: saving
        })
      );

      sessionStorage.removeItem(
        'rpDiscountRemoved'
      );

      sessionStorage.removeItem(
        'rpRemovedDiscountCode'
      );

    } catch (error) {}

  }


  function clearStoredDiscount() {

    try {

      sessionStorage.removeItem(
        'rpCartDiscount'
      );

    } catch (error) {}

  }


  function markDiscountRemoved(code) {

    try {

      sessionStorage.setItem(
        'rpDiscountRemoved',
        'true'
      );

      if (code) {

        sessionStorage.setItem(
          'rpRemovedDiscountCode',
          code
        );

      }

    } catch (error) {}

  }


  function clearDiscountRemovedFlag() {

    try {

      sessionStorage.removeItem(
        'rpDiscountRemoved'
      );

      sessionStorage.removeItem(
        'rpRemovedDiscountCode'
      );

    } catch (error) {}

  }


  function wasDiscountRemoved() {

    try {

      return (
        sessionStorage.getItem(
          'rpDiscountRemoved'
        ) === 'true'
      );

    } catch (error) {

      return false;

    }

  }


  function getRemovedDiscountCode() {

    try {

      return (
        sessionStorage.getItem(
          'rpRemovedDiscountCode'
        ) || ''
      );

    } catch (error) {

      return '';

    }

  }


  /* =========================================================
     CART NETWORK
     ========================================================= */


  function getCart() {

    return fetch(
      root + 'cart.js',
      {
        method: 'GET',

        headers: {
          'Accept': 'application/json'
        },

        cache: 'no-store'
      }
    )

    .then(function (response) {

      if (!response.ok) {

        throw new Error(
          'Unable to retrieve cart.'
        );

      }

      return response.json();

    });

  }


  function sendDiscountUpdate(code) {

    return fetch(
      root + 'cart/update.js',
      {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },

        body: JSON.stringify({
          discount: code || ''
        })
      }
    )

    .then(function (response) {

      if (!response.ok) {

        throw new Error(
          'Unable to update discount.'
        );

      }

      return response.json();

    });

  }


  function normaliseCode(value) {

    return String(
      value || ''
    )
      .trim()
      .toUpperCase();

  }


  function getEnteredDiscountCodes(cart) {

    var codes = [];

    if (
      !cart ||
      !cart.discount_codes ||
      !cart.discount_codes.length
    ) {

      return codes;

    }

    for (
      var i = 0;
      i < cart.discount_codes.length;
      i++
    ) {

      var entry =
        cart.discount_codes[i];

      if (
        entry &&
        entry.code
      ) {

        codes.push(
          entry.code
        );

      }

    }

    return codes;

  }


  function cartContainsDiscountCode(
    cart,
    code
  ) {

    if (!cart) {
      return false;
    }

    var wanted =
      normaliseCode(code);


    if (
      cart.discount_codes &&
      cart.discount_codes.length
    ) {

      for (
        var dc = 0;
        dc < cart.discount_codes.length;
        dc++
      ) {

        if (
          normaliseCode(
            cart.discount_codes[dc].code
          ) === wanted
        ) {

          return true;

        }

      }

    }


    if (
      cart.cart_level_discount_applications &&
      cart.cart_level_discount_applications.length
    ) {

      for (
        var c = 0;
        c <
        cart.cart_level_discount_applications.length;
        c++
      ) {

        if (
          normaliseCode(
            cart.cart_level_discount_applications[c].title
          ) === wanted
        ) {

          return true;

        }

      }

    }


    if (
      cart.items &&
      cart.items.length
    ) {

      for (
        var i = 0;
        i < cart.items.length;
        i++
      ) {

        var item =
          cart.items[i];


        if (
          item.discounts &&
          item.discounts.length
        ) {

          for (
            var d = 0;
            d < item.discounts.length;
            d++
          ) {

            if (
              normaliseCode(
                item.discounts[d].title
              ) === wanted
            ) {

              return true;

            }

          }

        }


        if (
          item.line_level_discount_allocations &&
          item.line_level_discount_allocations.length
        ) {

          for (
            var a = 0;
            a <
            item.line_level_discount_allocations.length;
            a++
          ) {

            var application =
              item
                .line_level_discount_allocations[a]
                .discount_application ||
              {};

            if (
              normaliseCode(
                application.title
              ) === wanted
            ) {

              return true;

            }

          }

        }

      }

    }


    return false;

  }


  function wait(milliseconds) {

    return new Promise(
      function (resolve) {

        setTimeout(
          resolve,
          milliseconds
        );

      }
    );

  }


  /*
   * =========================================================
   * TARGETED DISCOUNT REMOVAL
   * =========================================================
   */


  function removeSpecificDiscountCode(
    code,
    attempt
  ) {

    attempt =
      attempt || 1;

    if (!code) {

      return getCart();

    }


    var wanted =
      normaliseCode(
        code
      );


    return getCart()

    .then(function (cart) {

      var enteredCodes =
        getEnteredDiscountCodes(
          cart
        );


      var remainingCodes =
        [];


      var found =
        false;


      for (
        var i = 0;
        i < enteredCodes.length;
        i++
      ) {

        if (
          normaliseCode(
            enteredCodes[i]
          ) === wanted
        ) {

          found =
            true;

        } else {

          remainingCodes.push(
            enteredCodes[i]
          );

        }

      }


      if (!found) {

        return cart;

      }


      return sendDiscountUpdate(
        remainingCodes.join(',')
      )

      .then(function () {

        return wait(
          150
        );

      })

      .then(function () {

        return getCart();

      })

      .then(function (
        refreshedCart
      ) {

        if (
          !cartContainsDiscountCode(
            refreshedCart,
            code
          )
        ) {

          return refreshedCart;

        }


        if (
          attempt >= 4
        ) {

          throw new Error(
            'Manual discount is still attached to the cart.'
          );

        }


        return wait(
          180
        )

        .then(function () {

          return removeSpecificDiscountCode(
            code,
            attempt + 1
          );

        });

      });

    });

  }


  function clearDiscountVerified(
    code
  ) {

    return removeSpecificDiscountCode(
      code,
      1
    );

  }


  /* =========================================================
     LIVE PROMO CODE SAVING
     ========================================================= */


  function getDiscountSavingForCode(
    cart,
    code
  ) {

    if (
      !cart ||
      !code
    ) {
      return 0;
    }


    var wanted =
      normaliseCode(
        code
      );


    /*
     * =====================================================
     * PRIMARY SOURCE:
     * line_level_discount_allocations
     * =====================================================
     *
     * Shopify may expose the same line-item discount in both
     * line_level_discount_allocations AND item.discounts.
     *
     * These representations must NOT be added together.
     *
     * If matching line allocations exist, use those alone.
     * =====================================================
     */

    var allocationTotal =
      0;

    var allocationFound =
      false;


    if (
      cart.items &&
      cart.items.length
    ) {

      for (
        var i = 0;
        i < cart.items.length;
        i++
      ) {

        var item =
          cart.items[i];


        if (
          item.line_level_discount_allocations &&
          item.line_level_discount_allocations.length
        ) {

          for (
            var a = 0;
            a <
            item.line_level_discount_allocations.length;
            a++
          ) {

            var allocation =
              item
                .line_level_discount_allocations[a];


            var application =
              allocation.discount_application ||
              {};


            if (
              normaliseCode(
                application.title
              ) === wanted
            ) {

              if (
                typeof allocation.amount ===
                'number'
              ) {

                allocationTotal +=
                  allocation.amount;

                allocationFound =
                  true;

              }

            }

          }

        }

      }

    }


    if (
      allocationFound &&
      allocationTotal > 0
    ) {

      return Math.max(
        0,
        allocationTotal
      );

    }


    /*
     * =====================================================
     * FALLBACK SOURCE:
     * item.discounts
     * =====================================================
     *
     * Only use item.discounts when no matching line-level
     * allocations were found.
     * =====================================================
     */

    var itemDiscountTotal =
      0;

    var itemDiscountFound =
      false;


    if (
      cart.items &&
      cart.items.length
    ) {

      for (
        var j = 0;
        j < cart.items.length;
        j++
      ) {

        var discountItem =
          cart.items[j];


        if (
          discountItem.discounts &&
          discountItem.discounts.length
        ) {

          for (
            var d = 0;
            d < discountItem.discounts.length;
            d++
          ) {

            var itemDiscount =
              discountItem.discounts[d];


            if (
              normaliseCode(
                itemDiscount.title
              ) === wanted
            ) {

              if (
                typeof itemDiscount.amount ===
                'number'
              ) {

                itemDiscountTotal +=
                  itemDiscount.amount;

                itemDiscountFound =
                  true;

              }

            }

          }

        }

      }

    }


    if (
      itemDiscountFound &&
      itemDiscountTotal > 0
    ) {

      return Math.max(
        0,
        itemDiscountTotal
      );

    }


    /*
     * Cart-level discount fallback.
     */

    if (
      cart.cart_level_discount_applications &&
      cart.cart_level_discount_applications.length
    ) {

      for (
        var c = 0;
        c <
        cart.cart_level_discount_applications.length;
        c++
      ) {

        var cartApplication =
          cart.cart_level_discount_applications[c];


        if (
          normaliseCode(
            cartApplication.title
          ) === wanted
        ) {

          if (
            typeof cartApplication.total_allocated_amount ===
              'number' &&
            cartApplication.total_allocated_amount > 0
          ) {

            return Math.max(
              0,
              cartApplication.total_allocated_amount
            );

          }

        }

      }

    }


    /*
     * Final safety fallback:
     * compare Shopify's original and final cart totals.
     */

    if (
      cartContainsDiscountCode(
        cart,
        code
      ) &&
      typeof cart.original_total_price ===
        'number' &&
      typeof cart.total_price ===
        'number'
    ) {

      var difference =
        cart.original_total_price -
        cart.total_price;


      if (
        difference > 0
      ) {

        return difference;

      }

    }


    if (
      cartContainsDiscountCode(
        cart,
        code
      ) &&
      typeof cart.total_discount ===
        'number' &&
      cart.total_discount > 0
    ) {

      return cart.total_discount;

    }


    return 0;

  }


  /* =========================================================
     WSAIO PRICE DETECTION
     ========================================================= */


  function readExistingWsaioprice(item) {

    if (
      !item ||
      !item.variant_id
    ) {

      return null;

    }


    var selectors = [

      '.wsaio_' +
      item.variant_id +
      '.product-pricing .price--main',

      '.wsaio_' +
      item.variant_id +
      ' .price--main',

      '.wsaio_' +
      item.variant_id +
      ' .rps_final_price',

      '.wsaio_' +
      item.product_id +
      '.product-pricing .price--main',

      '.wsaio_' +
      item.product_id +
      ' .price--main',

      '.wsaio_' +
      item.product_id +
      ' .rps_final_price'

    ];


    for (
      var i = 0;
      i < selectors.length;
      i++
    ) {

      var elements;

      try {

        elements =
          document.querySelectorAll(
            selectors[i]
          );

      } catch (error) {

        elements =
          [];

      }


      for (
        var e = 0;
        e < elements.length;
        e++
      ) {

        if (
          elements[e].closest(
            '[data-rp-wsaio-probe]'
          )
        ) {

          continue;

        }


        var price =
          parseMoneyText(
            elements[e].textContent
          );


        if (
          price !== null &&
          price >= 0
        ) {

          return price;

        }

      }

    }


    return null;

  }


  function createWsaiopriceProbe(item) {

    return new Promise(
      function (resolve) {

        var normalPrice =
          getShopifyUnitPrice(
            item
          );


        if (
          !normalPrice ||
          !item.variant_id ||
          !item.product_id
        ) {

          resolve(
            null
          );

          return;

        }


        var existing =
          readExistingWsaioprice(
            item
          );


        if (
          existing !== null &&
          existing < normalPrice
        ) {

          resolve(
            existing
          );

          return;

        }


        var probe =
          document.createElement(
            'div'
          );


        probe.setAttribute(
          'data-rp-wsaio-probe',
          String(
            item.variant_id
          )
        );


        probe.className =
          'product-pricing ' +
          'wsaio_' +
          item.variant_id +
          ' ' +
          'wsapp ' +
          'wsaio_' +
          item.product_id;


        probe.style.position =
          'fixed';

        probe.style.left =
          '-10000px';

        probe.style.top =
          '0';

        probe.style.width =
          '200px';

        probe.style.height =
          '40px';

        probe.style.opacity =
          '0.01';

        probe.style.pointerEvents =
          'none';

        probe.style.zIndex =
          '-1';


        var priceElement =
          document.createElement(
            'div'
          );


        priceElement.className =
          'price--main';


        priceElement.textContent =
          formatMoney(
            normalPrice
          );


        probe.appendChild(
          priceElement
        );


        document.body.appendChild(
          probe
        );


        var finished =
          false;

        var timer =
          null;

        var observer =
          null;

        var start =
          Date.now();


        function cleanup(result) {

          if (finished) {
            return;
          }


          finished =
            true;


          if (timer) {

            clearInterval(
              timer
            );

          }


          if (observer) {

            observer.disconnect();

          }


          try {

            if (
              probe &&
              probe.parentNode
            ) {

              probe.parentNode.removeChild(
                probe
              );

            }

          } catch (error) {}


          resolve(
            result
          );

        }


        function inspectPrice() {

          var currentPrice =
            parseMoneyText(
              priceElement.textContent
            );


          var replacement =
            probe.querySelector(
              '.price--main, .rps_final_price'
            );


          if (replacement) {

            var replacementPrice =
              parseMoneyText(
                replacement.textContent
              );


            if (
              replacementPrice !== null
            ) {

              currentPrice =
                replacementPrice;

            }

          }


          if (
            currentPrice !== null &&
            currentPrice < normalPrice
          ) {

            cleanup(
              currentPrice
            );

            return;

          }


          var pagePrice =
            readExistingWsaioprice(
              item
            );


          if (
            pagePrice !== null &&
            pagePrice < normalPrice
          ) {

            cleanup(
              pagePrice
            );

            return;

          }


          if (
            Date.now() -
            start >= 6500
          ) {

            cleanup(
              null
            );

          }

        }


        if (
          'MutationObserver' in window
        ) {

          observer =
            new MutationObserver(
              inspectPrice
            );


          observer.observe(
            probe,
            {
              subtree: true,
              childList: true,
              characterData: true,
              attributes: true
            }
          );

        }


        timer =
          setInterval(
            inspectPrice,
            120
          );


        inspectPrice();

      }
    );

  }


  function getWsaioprice(item) {

    if (
      !customerIsLoggedIn()
    ) {

      return Promise.resolve(
        null
      );

    }


    var normalPrice =
      getShopifyUnitPrice(
        item
      );


    var key =
      String(
        item.variant_id
      ) +
      ':' +
      String(
        normalPrice
      );


    if (
      typeof wsaioPriceCache[key] ===
        'number' &&
      wsaioPriceCache[key] >= 0 &&
      wsaioPriceCache[key] < normalPrice
    ) {

      return Promise.resolve(
        wsaioPriceCache[key]
      );

    }


    return createWsaiopriceProbe(
      item
    )

    .then(function (
      price
    ) {

      if (
        typeof price ===
          'number' &&
        price >= 0 &&
        price < normalPrice
      ) {

        wsaioPriceCache[key] =
          price;

      }


      return price;

    })

    .catch(function () {

      return null;

    });

  }


  function resolveWsaiopricing(cart) {

    if (
      !cart ||
      !cart.items ||
      !cart.items.length ||
      !customerIsLoggedIn()
    ) {

      return Promise.resolve({
        hasTradePricing: false,
        totalSaving: 0,
        totalPrice:
          cart &&
          typeof cart.total_price ===
          'number'
            ? cart.total_price
            : 0,
        lines: []
      });

    }


    var lines =
      [];


    var chain =
      Promise.resolve();


    cart.items.forEach(
      function (item) {

        chain =
          chain.then(
            function () {

              return getWsaioprice(
                item
              )

              .then(function (
                wsaioUnitPrice
              ) {

                var normalUnitPrice =
                  getShopifyUnitPrice(
                    item
                  );


                var quantity =
                  item.quantity || 1;


                var normalLinePrice =
                  normalUnitPrice *
                  quantity;


                var shopifyLinePrice =
                  getDisplayLinePrice(
                    item
                  );


                var hasTradePrice =
                  (
                    typeof wsaioUnitPrice ===
                    'number'
                  ) &&
                  wsaioUnitPrice >= 0 &&
                  wsaioUnitPrice <
                    normalUnitPrice;


                var finalLinePrice =
                  hasTradePrice
                    ? (
                        wsaioUnitPrice *
                        quantity
                      )
                    : shopifyLinePrice;


                var saving =
                  hasTradePrice
                    ? (
                        normalLinePrice -
                        finalLinePrice
                      )
                    : 0;


                lines.push({

                  variantId:
                    item.variant_id,

                  hasTradePrice:
                    hasTradePrice,

                  originalLinePrice:
                    normalLinePrice,

                  finalLinePrice:
                    finalLinePrice,

                  saving:
                    Math.max(
                      0,
                      saving
                    )

                });

              });

            }
          );

      }
    );


    return chain

    .then(function () {

      var hasTradePricing =
        false;

      var totalSaving =
        0;

      var totalPrice =
        0;


      for (
        var i = 0;
        i < lines.length;
        i++
      ) {

        if (
          lines[i].hasTradePrice
        ) {

          hasTradePricing =
            true;

        }


        totalSaving +=
          lines[i].saving;


        totalPrice +=
          lines[i].finalLinePrice;

      }


      return {

        hasTradePricing:
          hasTradePricing,

        totalSaving:
          totalSaving,

        totalPrice:
          totalPrice,

        lines:
          lines

      };

    });

  }


  /* =========================================================
     TRADE UI STATE
     ========================================================= */


  function setTradeUiState(
    active,
    saving
  ) {

    tradePricingActive =
      !!active;


    if (
      tradePricingActive
    ) {

      markTradeSession();

    }


    var protectTradeSession =
      tradePricingActive ||
      isKnownTradeSession();


    if (drawer) {

      drawer.classList.toggle(
        'rp-trade-pricing-active',
        protectTradeSession
      );

    }


    if (discount) {

      discount.hidden =
        protectTradeSession;

    }


    if (
      protectTradeSession
    ) {

      hideAppliedDiscount();

      clearDiscountMessage();

    }


    if (tradeSummary) {

      tradeSummary.hidden =
        !(
          tradePricingActive &&
          saving > 0
        );

    }


    if (tradeSaving) {

      tradeSaving.textContent =
        tradePricingActive &&
        saving > 0
          ? '-' +
            formatMoney(
              saving
            )
          : '';

    }


    refreshCheckoutObserver();

  }


  function applyWsaiopricingToDrawer(result) {

    if (
      !result ||
      !content
    ) {
      return;
    }


    for (
      var i = 0;
      i < result.lines.length;
      i++
    ) {

      var line =
        i + 1;


      var data =
        result.lines[i];


      var itemElement =
        content.querySelector(
          '[data-rp-cart-line="' +
          line +
          '"]'
        );


      if (!itemElement) {
        continue;
      }


      var finalPriceElement =
        itemElement.querySelector(
          '[data-rp-final-price]'
        );


      var originalPriceElement =
        itemElement.querySelector(
          '[data-rp-original-price]'
        );


      var savingElement =
        itemElement.querySelector(
          '[data-rp-trade-saving]'
        );


      if (finalPriceElement) {

        finalPriceElement.textContent =
          formatMoney(
            data.finalLinePrice
          );


        finalPriceElement.classList.toggle(
          'is-trade-price',
          data.hasTradePrice
        );

      }


      if (originalPriceElement) {

        originalPriceElement.hidden =
          !data.hasTradePrice;


        originalPriceElement.textContent =
          data.hasTradePrice
            ? formatMoney(
                data.originalLinePrice
              )
            : '';

      }


      if (savingElement) {

        savingElement.hidden =
          !(
            data.hasTradePrice &&
            data.saving > 0
          );


        savingElement.textContent =
          (
            data.hasTradePrice &&
            data.saving > 0
          )
            ? (
                'Trade saving ' +
                formatMoney(
                  data.saving
                )
              )
            : '';

      }

    }


    setTradeUiState(
      result.hasTradePricing,
      result.totalSaving
    );


    if (
      result.hasTradePricing
    ) {

      var formattedTotal =
        formatMoney(
          result.totalPrice
        );


      if (total) {

        total.textContent =
          formattedTotal;

      }


      if (mobileTotal) {

        mobileTotal.textContent =
          formattedTotal;

      }

    }


    refreshCheckoutObserver();

  }


  function removeStoredManualDiscountForTrade(
    cart
  ) {

    var stored =
      getStoredDiscount();


    if (
      !stored ||
      !stored.code
    ) {

      clearStoredDiscount();

      return Promise.resolve(
        cart
      );

    }


    var code =
      stored.code;


    clearStoredDiscount();


    if (
      !cartContainsDiscountCode(
        cart,
        code
      )
    ) {

      return Promise.resolve(
        cart
      );

    }


    return removeSpecificDiscountCode(
      code
    );

  }


  function refreshWsaiopricing(cart) {

    var generation =
      ++tradePricingGeneration;


    resolveWsaiopricing(
      cart
    )

    .then(function (result) {

      if (
        generation !==
        tradePricingGeneration
      ) {
        return;
      }


      if (
        result.hasTradePricing
      ) {

        markTradeSession();


        setTradeUiState(
          true,
          result.totalSaving
        );


        return removeStoredManualDiscountForTrade(
          cart
        )

        .then(function (
          refreshedCart
        ) {

          if (
            generation !==
            tradePricingGeneration
          ) {
            return;
          }


          if (
            refreshedCart &&
            refreshedCart.token &&
            cart &&
            (
              refreshedCart.total_price !==
                cart.total_price ||
              getEnteredDiscountCodes(
                refreshedCart
              ).join('|') !==
              getEnteredDiscountCodes(
                cart
              ).join('|')
            )
          ) {

            renderCart(
              refreshedCart
            );

            return;

          }


          applyWsaiopricingToDrawer(
            result
          );

        });

      }


      if (
        isKnownTradeSession()
      ) {

        setTradeUiState(
          false,
          0
        );


        return removeStoredManualDiscountForTrade(
          cart
        )

        .then(function () {

          applyWsaiopricingToDrawer(
            result
          );

        });

      }


      applyWsaiopricingToDrawer(
        result
      );

    })

    .catch(function (error) {

      console.warn(
        'WSAIO drawer pricing:',
        error
      );


      if (
        generation ===
        tradePricingGeneration
      ) {

        setTradeUiState(
          false,
          0
        );

      }

    });

  }


  /* =========================================================
     MOBILE CHECKOUT
     ========================================================= */


  function hideMobileCheckout() {

    if (
      !drawer ||
      !mobileCheckout
    ) {
      return;
    }


    drawer.classList.remove(
      'rp-mobile-checkout-sticky'
    );


    mobileCheckout.setAttribute(
      'aria-hidden',
      'true'
    );

  }


  function showMobileCheckout() {

    if (
      !drawer ||
      !mobileCheckout
    ) {
      return;
    }


    if (
      window.innerWidth > 767
    ) {

      hideMobileCheckout();

      return;

    }


    if (
      footer &&
      footer.hidden
    ) {

      hideMobileCheckout();

      return;

    }


    drawer.classList.add(
      'rp-mobile-checkout-sticky'
    );


    mobileCheckout.setAttribute(
      'aria-hidden',
      'false'
    );

  }


  function setupCheckoutObserver() {

    if (checkoutObserver) {

      checkoutObserver.disconnect();

      checkoutObserver =
        null;

    }


    if (
      !normalCheckoutButton ||
      !scrollArea ||
      !mobileCheckout
    ) {

      hideMobileCheckout();

      return;

    }


    if (
      window.innerWidth > 767
    ) {

      hideMobileCheckout();

      return;

    }


    if (
      !('IntersectionObserver' in window)
    ) {

      hideMobileCheckout();

      return;

    }


    checkoutObserver =
      new IntersectionObserver(
        function (entries) {

          if (
            !entries ||
            !entries.length
          ) {
            return;
          }


          var entry =
            entries[0];


          if (
            entry.isIntersecting &&
            entry.intersectionRatio >= 0.55
          ) {

            hideMobileCheckout();

          } else {

            showMobileCheckout();

          }

        },
        {
          root:
            scrollArea,

          threshold: [
            0,
            0.25,
            0.55,
            0.75,
            1
          ]
        }
      );


    checkoutObserver.observe(
      normalCheckoutButton
    );

  }


  function refreshCheckoutObserver() {

    requestAnimationFrame(
      setupCheckoutObserver
    );


    setTimeout(
      setupCheckoutObserver,
      120
    );


    setTimeout(
      setupCheckoutObserver,
      400
    );

  }


  /* =========================================================
     OPEN / CLOSE
     ========================================================= */


  function openDrawer() {

    if (
      !drawer ||
      !overlay
    ) {
      return;
    }


    drawer.classList.add(
      'is-open'
    );


    overlay.classList.add(
      'is-visible'
    );


    drawer.setAttribute(
      'aria-hidden',
      'false'
    );


    overlay.setAttribute(
      'aria-hidden',
      'false'
    );


    document.body.classList.add(
      'rp-cart-drawer-open'
    );


    refreshCheckoutObserver();

  }


  function closeDrawer() {

    if (
      !drawer ||
      !overlay
    ) {
      return;
    }


    drawer.classList.remove(
      'is-open'
    );


    overlay.classList.remove(
      'is-visible'
    );


    drawer.setAttribute(
      'aria-hidden',
      'true'
    );


    overlay.setAttribute(
      'aria-hidden',
      'true'
    );


    document.body.classList.remove(
      'rp-cart-drawer-open'
    );


    hideMobileCheckout();

  }


  /* =========================================================
     ITEM RENDERING
     ========================================================= */


  function getVariantText(item) {

    if (
      !item ||
      !item.options_with_values ||
      !item.options_with_values.length
    ) {
      return '';
    }


    var values =
      [];


    item.options_with_values.forEach(
      function (option) {

        if (
          option.value &&
          option.value !==
          'Default Title'
        ) {

          values.push(
            option.value
          );

        }

      }
    );


    return values.join(
      ', '
    );

  }


  function buildItem(
    item,
    lineNumber,
    showOriginalRetailPrice
  ) {

    var variant =
      getVariantText(
        item
      );


    var image =
      item.featured_image &&
      item.featured_image.url
        ? item.featured_image.url
        : item.image;


    var imageHtml =
      '';


    if (image) {

      imageHtml =

        '<a ' +
          'class="rp-drawer-item-image-wrap" ' +
          'href="' +
          escapeHtml(
            item.url
          ) +
        '">' +

          '<img ' +
            'class="rp-drawer-item-image" ' +
            'src="' +
            escapeHtml(
              image
            ) +
            '" ' +
            'alt="' +
            escapeHtml(
              item.product_title
            ) +
          '">' +

        '</a>';

    } else {

      imageHtml =

        '<div ' +
          'class="rp-drawer-item-image-wrap">' +
        '</div>';

    }


    var variantHtml =
      '';


    if (variant) {

      variantHtml =

        '<div ' +
          'class="rp-drawer-variant">' +

          escapeHtml(
            variant
          ) +

        '</div>';

    }


    var displayLinePrice =
      showOriginalRetailPrice
        ? getOriginalRetailLinePrice(
            item
          )
        : getDisplayLinePrice(
            item
          );


    return (

      '<article ' +
        'class="rp-drawer-item" ' +
        'data-rp-cart-line="' +
        lineNumber +
      '">' +

        imageHtml +

        '<div ' +
          'class="rp-drawer-item-info">' +

          '<div ' +
            'class="rp-drawer-item-top">' +

            '<a ' +
              'class="rp-drawer-item-title" ' +
              'href="' +
              escapeHtml(
                item.url
              ) +
            '">' +

              escapeHtml(
                item.product_title
              ) +

            '</a>' +

            '<span ' +
              'class="rp-drawer-item-price">' +

              '<span ' +
                'class="rp-drawer-original-price" ' +
                'data-rp-original-price ' +
                'hidden' +
              '></span>' +

              '<span ' +
                'class="rp-drawer-final-price" ' +
                'data-rp-final-price' +
              '>' +

                formatMoney(
                  displayLinePrice
                ) +

              '</span>' +

            '</span>' +

          '</div>' +

          variantHtml +

          '<div ' +
            'class="rp-drawer-trade-saving" ' +
            'data-rp-trade-saving ' +
            'hidden' +
          '></div>' +

          '<div ' +
            'class="rp-drawer-item-bottom">' +

            '<div ' +
              'class="rp-drawer-quantity">' +

              '<button ' +
                'type="button" ' +
                'class="rp-drawer-qty-button" ' +
                'data-rp-qty-minus ' +
                'aria-label="Decrease quantity"' +
              '>' +

                '&minus;' +

              '</button>' +

              '<span ' +
                'class="rp-drawer-qty-value">' +

                item.quantity +

              '</span>' +

              '<button ' +
                'type="button" ' +
                'class="rp-drawer-qty-button" ' +
                'data-rp-qty-plus ' +
                'aria-label="Increase quantity"' +
              '>' +

                '+' +

              '</button>' +

            '</div>' +

            '<button ' +
              'type="button" ' +
              'class="rp-drawer-remove" ' +
              'data-rp-remove' +
            '>' +

              'Remove' +

            '</button>' +

          '</div>' +

          '<div ' +
            'class="rp-drawer-stock-message" ' +
            'data-rp-stock-message ' +
            'role="status" ' +
            'aria-live="polite"' +
          '></div>' +

        '</div>' +

      '</article>'

    );

  }


  function updateHeaderBadge(cart) {

    var headerCounts =
      document.querySelectorAll(
        '[data-header-cart-count]'
      );


    for (
      var h = 0;
      h < headerCounts.length;
      h++
    ) {

      headerCounts[h].setAttribute(
        'data-header-cart-count',
        cart.item_count
      );


      headerCounts[h].textContent =
        '';


      if (
        cart.item_count > 0
      ) {

        headerCounts[h]
          .classList.add(
            'visible'
          );

      } else {

        headerCounts[h]
          .classList.remove(
            'visible'
          );

      }

    }

  }


  /* =========================================================
     DISCOUNT UI
     ========================================================= */


  function openDiscount() {

    if (
      !discount ||
      tradePricingActive ||
      isKnownTradeSession()
    ) {
      return;
    }


    discount.classList.add(
      'is-open'
    );


    if (discountToggle) {

      discountToggle.setAttribute(
        'aria-expanded',
        'true'
      );

    }


    if (discountContent) {

      discountContent.setAttribute(
        'aria-hidden',
        'false'
      );

    }


    refreshCheckoutObserver();

  }


  function closeDiscount() {

    if (!discount) {
      return;
    }


    discount.classList.remove(
      'is-open'
    );


    if (discountToggle) {

      discountToggle.setAttribute(
        'aria-expanded',
        'false'
      );

    }


    if (discountContent) {

      discountContent.setAttribute(
        'aria-hidden',
        'true'
      );

    }


    refreshCheckoutObserver();

  }


  function clearDiscountMessage() {

    if (!discountMessage) {
      return;
    }


    discountMessage.textContent =
      '';


    discountMessage.classList.remove(
      'is-error',
      'is-success'
    );


    if (discountInput) {

      discountInput.classList.remove(
        'is-error'
      );

    }

  }


  function showDiscountError(message) {

    if (
      tradePricingActive ||
      isKnownTradeSession()
    ) {
      return;
    }


    openDiscount();


    if (discountMessage) {

      discountMessage.textContent =
        message;


      discountMessage.classList.remove(
        'is-success'
      );


      discountMessage.classList.add(
        'is-error'
      );

    }


    if (discountInput) {

      discountInput.classList.add(
        'is-error'
      );

    }


    refreshCheckoutObserver();

  }


  function showAppliedDiscount(
    code,
    saving
  ) {

    if (
      !appliedDiscount ||
      tradePricingActive ||
      isKnownTradeSession()
    ) {
      return;
    }


    if (appliedCode) {

      appliedCode.textContent =
        code;

    }


    if (appliedSaving) {

      appliedSaving.textContent =
        '-' +
        formatMoney(
          Math.max(
            0,
            saving
          )
        );

    }


    appliedDiscount.hidden =
      false;


    closeDiscount();


    refreshCheckoutObserver();

  }


  function hideAppliedDiscount() {

    if (!appliedDiscount) {
      return;
    }


    appliedDiscount.hidden =
      true;


    if (appliedCode) {

      appliedCode.textContent =
        '';

    }


    if (appliedSaving) {

      appliedSaving.textContent =
        '';

    }


    refreshCheckoutObserver();

  }


  /* =========================================================
     STOCK MESSAGES
     ========================================================= */


  function clearStockMessages() {

    if (!drawer) {
      return;
    }


    var messages =
      drawer.querySelectorAll(
        '[data-rp-stock-message]'
      );


    for (
      var i = 0;
      i < messages.length;
      i++
    ) {

      messages[i].textContent =
        '';


      messages[i].classList.remove(
        'is-visible'
      );

    }

  }


  function showStockMessage(
    line,
    message
  ) {

    if (!drawer) {
      return;
    }


    var item =
      drawer.querySelector(
        '[data-rp-cart-line="' +
        line +
        '"]'
      );


    if (!item) {
      return;
    }


    var messageElement =
      item.querySelector(
        '[data-rp-stock-message]'
      );


    if (!messageElement) {
      return;
    }


    messageElement.textContent =
      message;


    messageElement.classList.add(
      'is-visible'
    );


    setTimeout(
      function () {

        if (
          messageElement &&
          document.body.contains(
            messageElement
          )
        ) {

          messageElement.textContent =
            '';


          messageElement.classList.remove(
            'is-visible'
          );

        }

      },
      4000
    );

  }


  /* =========================================================
     CART RENDER
     ========================================================= */


  function renderCart(cart) {

    if (
      !content ||
      !footer ||
      !count ||
      !total
    ) {
      return;
    }


    tradePricingGeneration++;


    setTradeUiState(
      false,
      0
    );


    count.textContent =
      cart.item_count;


    updateHeaderBadge(
      cart
    );


    if (
      !cart.items ||
      !cart.items.length
    ) {

      content.innerHTML =

        '<div ' +
          'class="rp-drawer-empty">' +

          '<h3>' +
            'Your cart is empty' +
          '</h3>' +

          '<p>' +
            'Add something to your cart to get started.' +
          '</p>' +

          '<a ' +
            'href="/collections/all" ' +
            'class="button-primary"' +
          '>' +

            'Continue shopping' +

          '</a>' +

        '</div>';


      footer.hidden =
        true;


      hideAppliedDiscount();


      clearStoredDiscount();


      hideMobileCheckout();


      return;

    }


    /*
     * Determine whether this is a normal retail cart with
     * one of OUR manually entered promo codes currently
     * attached.
     *
     * If so, product lines show their pre-promo prices.
     *
     * Trade sessions are excluded completely.
     */

    var storedPromo =
      getStoredDiscount();


    var retailPromoActive =
      (
        !isKnownTradeSession() &&
        storedPromo &&
        storedPromo.code &&
        !wasDiscountRemoved() &&
        cartContainsDiscountCode(
          cart,
          storedPromo.code
        )
      );


    var html =
      '';


    cart.items.forEach(
      function (
        item,
        index
      ) {

        html +=
          buildItem(
            item,
            index + 1,
            retailPromoActive
          );

      }
    );


    content.innerHTML =
      html;


    /*
     * Shopify's total_price already contains the retail promo
     * deduction. Keep this as the authoritative Estimated Total.
     */

    var formattedTotal =
      formatMoney(
        cart.total_price
      );


    total.textContent =
      formattedTotal;


    if (mobileTotal) {

      mobileTotal.textContent =
        formattedTotal;

    }


    footer.hidden =
      false;


    /*
     * Normal customers retain dynamic promo saving display.
     */

    if (
      !isKnownTradeSession()
    ) {

      var stored =
        getStoredDiscount();


      if (
        stored &&
        stored.code &&
        !wasDiscountRemoved() &&
        cartContainsDiscountCode(
          cart,
          stored.code
        )
      ) {

        var currentPromoSaving =
          getDiscountSavingForCode(
            cart,
            stored.code
          );


        if (
          currentPromoSaving > 0
        ) {

          storeDiscount(
            stored.code,
            currentPromoSaving
          );


          showAppliedDiscount(
            stored.code,
            currentPromoSaving
          );

        } else {

          hideAppliedDiscount();

        }

      } else {

        hideAppliedDiscount();

      }

    } else {

      hideAppliedDiscount();

    }


    refreshCheckoutObserver();


    refreshWsaiopricing(
      cart
    );

  }


  function refreshCart(openAfter) {

    if (refreshTimer) {

      clearTimeout(
        refreshTimer
      );

    }


    refreshTimer =
      setTimeout(
        function () {

          var promise;


          if (
            wasDiscountRemoved()
          ) {

            promise =
              clearDiscountVerified(
                getRemovedDiscountCode()
              );

          } else {

            promise =
              getCart();

          }


          promise

          .then(function (cart) {

            renderCart(
              cart
            );


            if (openAfter) {

              openDrawer();

            }

          })

          .catch(function (error) {

            console.error(
              'Cart drawer refresh:',
              error
            );


            return getCart()

            .then(function (cart) {

              renderCart(
                cart
              );


              if (openAfter) {

                openDrawer();

              }

            });

          });

        },
        50
      );

  }


  /* =========================================================
     QUANTITY
     ========================================================= */


  function changeQuantity(
    line,
    quantity
  ) {

    if (
      cartActionRunning ||
      !line
    ) {

      return Promise.resolve();

    }


    cartActionRunning =
      true;


    clearStockMessages();


    return fetch(
      root + 'cart/change.js',
      {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },

        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      }
    )


    .then(function (response) {

      if (!response.ok) {

        return response
        .json()

        .catch(function () {

          return {};

        })

        .then(function (errorData) {

          var error =
            new Error(
              errorData.description ||
              errorData.message ||
              'Unable to update cart.'
            );


          error.cartErrorData =
            errorData;


          throw error;

        });

      }


      return response.json();

    })


    .then(function (cart) {

      var updatedItem =
        cart.items &&
        cart.items[line - 1]
          ? cart.items[line - 1]
          : null;


      var acceptedQuantity =
        updatedItem
          ? updatedItem.quantity
          : 0;


      var stockWasLimited =
        quantity > 0 &&
        acceptedQuantity < quantity;


      renderCart(
        cart
      );


      if (
        stockWasLimited
      ) {

        setTimeout(
          function () {

            showStockMessage(
              line,
              'Sorry, no more stock is available for this item.'
            );

          },
          30
        );

      }


      return cart;

    })


    .catch(function (error) {

      console.error(
        'Cart quantity update:',
        error
      );


      if (
        quantity > 0
      ) {

        showStockMessage(
          line,
          'Sorry, no more stock is available for this item.'
        );

      }


      return getCart()

      .then(function (cart) {

        renderCart(
          cart
        );


        return cart;

      });

    })


    .finally(function () {

      cartActionRunning =
        false;


      refreshCheckoutObserver();

    });

  }


  function handleDrawerClick(event) {

    var minus =
      event.target.closest(
        '[data-rp-qty-minus]'
      );


    var plus =
      event.target.closest(
        '[data-rp-qty-plus]'
      );


    var remove =
      event.target.closest(
        '[data-rp-remove]'
      );


    if (
      !minus &&
      !plus &&
      !remove
    ) {
      return;
    }


    event.preventDefault();


    if (
      cartActionRunning
    ) {
      return;
    }


    var item =
      event.target.closest(
        '[data-rp-cart-line]'
      );


    if (!item) {
      return;
    }


    var line =
      parseInt(
        item.getAttribute(
          'data-rp-cart-line'
        ),
        10
      );


    if (
      !line ||
      line < 1
    ) {
      return;
    }


    var valueElement =
      item.querySelector(
        '.rp-drawer-qty-value'
      );


    var currentQuantity =
      valueElement
        ? parseInt(
            valueElement.textContent,
            10
          )
        : 1;


    if (
      !currentQuantity ||
      currentQuantity < 1
    ) {

      currentQuantity =
        1;

    }


    if (minus) {

      changeQuantity(
        line,
        Math.max(
          0,
          currentQuantity - 1
        )
      );


      return;

    }


    if (plus) {

      changeQuantity(
        line,
        currentQuantity + 1
      );


      return;

    }


    if (remove) {

      changeQuantity(
        line,
        0
      );

    }

  }


  /* =========================================================
     APPLY NORMAL PROMO
     ========================================================= */


  function applyDiscount() {

    clearDiscountMessage();


    if (
      tradePricingActive ||
      isKnownTradeSession()
    ) {
      return;
    }


    if (
      cartActionRunning
    ) {
      return;
    }


    var code =
      discountInput
        ? discountInput.value.trim()
        : '';


    if (!code) {

      showDiscountError(
        'Please enter a discount code.'
      );


      return;

    }


    cartActionRunning =
      true;


    if (discountApply) {

      discountApply.disabled =
        true;


      discountApply.textContent =
        'Applying';

    }


    var baselineCart;


    clearDiscountRemovedFlag();


    var previousStored =
      getStoredDiscount();


    var preparation;


    if (
      previousStored &&
      previousStored.code
    ) {

      preparation =
        removeSpecificDiscountCode(
          previousStored.code
        );

    } else {

      preparation =
        getCart();

    }


    preparation

    .then(function (cart) {

      baselineCart =
        cart;


      return sendDiscountUpdate(
        code
      );

    })

    .then(function () {

      return wait(
        120
      );

    })

    .then(function () {

      return getCart();

    })

    .then(function (afterCart) {

      var codeExists =
        cartContainsDiscountCode(
          afterCart,
          code
        );


      var saving =
        getDiscountSavingForCode(
          afterCart,
          code
        );


      if (
        saving <= 0 &&
        baselineCart &&
        typeof baselineCart.total_price ===
          'number' &&
        typeof afterCart.total_price ===
          'number'
      ) {

        saving =
          baselineCart.total_price -
          afterCart.total_price;

      }


      if (
        codeExists &&
        saving > 0
      ) {

        storeDiscount(
          code,
          saving
        );


        renderCart(
          afterCart
        );


        showAppliedDiscount(
          code,
          saving
        );


        if (
          discountInput
        ) {

          discountInput.value =
            '';

        }


        clearDiscountMessage();


        return;

      }


      clearStoredDiscount();


      renderCart(
        afterCart
      );


      showDiscountError(
        'This discount code could not be applied to the items in your cart.'
      );

    })

    .catch(function (error) {

      console.error(
        'Discount apply:',
        error
      );


      showDiscountError(
        'We could not apply this discount code. Please try again.'
      );

    })

    .finally(function () {

      cartActionRunning =
        false;


      if (
        discountApply
      ) {

        discountApply.disabled =
          false;


        discountApply.textContent =
          'Apply';

      }


      refreshCheckoutObserver();

    });

  }


  function removeDiscount() {

    if (
      cartActionRunning ||
      !discountRemove
    ) {
      return;
    }


    cartActionRunning =
      true;


    discountRemove.disabled =
      true;


    var stored =
      getStoredDiscount();


    var code =
      stored &&
      stored.code
        ? stored.code
        : (
            appliedCode
              ? appliedCode.textContent
              : ''
          );


    markDiscountRemoved(
      code
    );


    clearDiscountVerified(
      code
    )

    .then(function (cart) {

      clearStoredDiscount();


      hideAppliedDiscount();


      clearDiscountMessage();


      renderCart(
        cart
      );

    })

    .catch(function (error) {

      console.error(
        'Discount removal:',
        error
      );


      clearDiscountRemovedFlag();


      return getCart()

      .then(function (cart) {

        renderCart(
          cart
        );

      });

    })

    .finally(function () {

      cartActionRunning =
        false;


      discountRemove.disabled =
        false;


      refreshCheckoutObserver();

    });

  }


  /* =========================================================
     CHECKOUT
     ========================================================= */


  function goToCheckout(event) {

    if (event) {

      event.preventDefault();

    }


    if (
      tradePricingActive ||
      isKnownTradeSession()
    ) {

      clearStoredDiscount();

      clearDiscountRemovedFlag();


      window.location.href =
        root + 'checkout';


      return;

    }


    if (
      !wasDiscountRemoved()
    ) {

      window.location.href =
        root + 'checkout';


      return;

    }


    var removedCode =
      getRemovedDiscountCode();


    clearDiscountVerified(
      removedCode
    )

    .then(function (cart) {

      if (
        cartContainsDiscountCode(
          cart,
          removedCode
        )
      ) {

        throw new Error(
          'Discount still present.'
        );

      }


      window.location.href =
        root + 'checkout';

    })

    .catch(function (error) {

      console.error(
        'Checkout discount verification:',
        error
      );


      alert(
        'We could not prepare your checkout. Please try again.'
      );

    });

  }


  /* =========================================================
     CART ADD INTERCEPTION
     ========================================================= */


  if (window.fetch) {

    var originalFetch =
      window.fetch;


    window.fetch =
      function () {

        var args =
          arguments;


        var request =
          args[0];


        var url =
          typeof request ===
          'string'
            ? request
            : (
                request &&
                request.url
                  ? request.url
                  : ''
              );


        return originalFetch
        .apply(
          this,
          args
        )

        .then(function (response) {

          if (
            url &&
            url.indexOf(
              '/cart/add'
            ) !== -1 &&
            response.ok
          ) {

            setTimeout(
              function () {

                refreshCart(
                  true
                );

              },
              220
            );

          }


          return response;

        });

      };

  }


  if (window.XMLHttpRequest) {

    var originalOpen =
      XMLHttpRequest.prototype.open;


    var originalSend =
      XMLHttpRequest.prototype.send;


    XMLHttpRequest.prototype.open =
      function (
        method,
        url
      ) {

        this._rpCartDrawerUrl =
          url || '';


        return originalOpen.apply(
          this,
          arguments
        );

      };


    XMLHttpRequest.prototype.send =
      function () {

        var xhr =
          this;


        xhr.addEventListener(
          'load',
          function () {

            if (
              xhr.status >= 200 &&
              xhr.status < 300 &&
              xhr._rpCartDrawerUrl &&
              xhr._rpCartDrawerUrl.indexOf(
                '/cart/add'
              ) !== -1
            ) {

              setTimeout(
                function () {

                  refreshCart(
                    true
                  );

                },
                220
              );

            }

          }
        );


        return originalSend.apply(
          this,
          arguments
        );

      };

  }


  /* =========================================================
     HEADER CART
     ========================================================= */


  document.addEventListener(
    'click',
    function (event) {

      var cartButton =
        event.target.closest(
          '.site-header-cart-button'
        );


      if (!cartButton) {
        return;
      }


      if (
        event.ctrlKey ||
        event.metaKey ||
        event.shiftKey ||
        event.altKey ||
        event.button === 1
      ) {
        return;
      }


      event.preventDefault();


      event.stopPropagation();


      event.stopImmediatePropagation();


      refreshCart(
        true
      );

    },
    true
  );


  /* =========================================================
     INIT
     ========================================================= */


  function init() {

    if (
      drawerInitialised
    ) {
      return;
    }


    drawer =
      document.getElementById(
        'rp-cart-drawer'
      );


    overlay =
      document.getElementById(
        'rp-cart-drawer-overlay'
      );


    closeButton =
      document.getElementById(
        'rp-drawer-close'
      );


    scrollArea =
      document.getElementById(
        'rp-drawer-scroll'
      );


    content =
      document.getElementById(
        'rp-drawer-content'
      );


    footer =
      document.getElementById(
        'rp-drawer-footer'
      );


    count =
      document.getElementById(
        'rp-drawer-count'
      );


    total =
      document.getElementById(
        'rp-drawer-total'
      );


    mobileTotal =
      document.getElementById(
        'rp-drawer-mobile-total'
      );


    mobileCheckout =
      document.getElementById(
        'rp-drawer-mobile-checkout'
      );


    mobileCheckoutButton =
      document.querySelector(
        '.rp-drawer-mobile-checkout-button'
      );


    normalCheckoutButton =
      document.querySelector(
        '.rp-drawer-primary-checkout .rp-drawer-checkout'
      );


    discount =
      document.getElementById(
        'rp-drawer-discount'
      );


    discountToggle =
      document.getElementById(
        'rp-drawer-discount-toggle'
      );


    discountContent =
      document.getElementById(
        'rp-drawer-discount-content'
      );


    discountInput =
      document.getElementById(
        'rp-drawer-discount-input'
      );


    discountApply =
      document.getElementById(
        'rp-drawer-discount-apply'
      );


    discountMessage =
      document.getElementById(
        'rp-drawer-discount-message'
      );


    appliedDiscount =
      document.getElementById(
        'rp-drawer-applied-discount'
      );


    appliedCode =
      document.getElementById(
        'rp-drawer-applied-code'
      );


    appliedSaving =
      document.getElementById(
        'rp-drawer-applied-saving'
      );


    discountRemove =
      document.getElementById(
        'rp-drawer-discount-remove'
      );


    tradeSummary =
      document.getElementById(
        'rp-drawer-trade-summary'
      );


    tradeSaving =
      document.getElementById(
        'rp-drawer-trade-saving'
      );


    if (
      !drawer ||
      !overlay ||
      !scrollArea
    ) {

      console.error(
        'Ratton cart drawer markup was not found.'
      );


      return;

    }


    drawerInitialised =
      true;


    if (
      !customerIsLoggedIn()
    ) {

      clearTradeSession();

    }


    if (closeButton) {

      closeButton.addEventListener(
        'click',
        closeDrawer
      );

    }


    overlay.addEventListener(
      'click',
      closeDrawer
    );


    drawer.addEventListener(
      'click',
      handleDrawerClick
    );


    if (discountToggle) {

      discountToggle.addEventListener(
        'click',
        function () {

          if (
            tradePricingActive ||
            isKnownTradeSession()
          ) {
            return;
          }


          if (
            discount.classList.contains(
              'is-open'
            )
          ) {

            closeDiscount();

          } else {

            openDiscount();


            setTimeout(
              function () {

                if (
                  discountInput
                ) {

                  discountInput.focus();

                }

              },
              50
            );

          }

        }
      );

    }


    if (discountApply) {

      discountApply.addEventListener(
        'click',
        function (event) {

          event.preventDefault();


          applyDiscount();

        }
      );

    }


    if (discountInput) {

      discountInput.addEventListener(
        'keydown',
        function (event) {

          if (
            event.key ===
            'Enter'
          ) {

            event.preventDefault();


            applyDiscount();

          }

        }
      );

    }


    if (discountRemove) {

      discountRemove.addEventListener(
        'click',
        function (event) {

          event.preventDefault();


          removeDiscount();

        }
      );

    }


    if (normalCheckoutButton) {

      normalCheckoutButton.addEventListener(
        'click',
        goToCheckout
      );

    }


    if (mobileCheckoutButton) {

      mobileCheckoutButton.addEventListener(
        'click',
        goToCheckout
      );

    }


    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key ===
          'Escape' &&
          drawer.classList.contains(
            'is-open'
          )
        ) {

          closeDrawer();

        }

      }
    );


    window.addEventListener(
      'resize',
      refreshCheckoutObserver
    );


    window.addEventListener(
      'orientationchange',
      function () {

        setTimeout(
          refreshCheckoutObserver,
          150
        );

      }
    );


    refreshCart(
      false
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }


  window.RattonCartDrawer = {

    open:
      function () {

        refreshCart(
          true
        );

      },

    close:
      closeDrawer,

    refresh:
      function () {

        refreshCart(
          false
        );

      }

  };


})();